import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config.json';

const SettingsContext = createContext();

const SETTINGS_KEY = 'gym_tracker_settings';

export const SettingsProvider = ({ children }) => {
  const [mapTileProvider, setMapTileProvider] = useState(config.map_tile_providers[0]);
  const [timezone, setTimezone] = useState(config.default_timezone);
  const [eventTimeSpan, setEventTimeSpan] = useState('Last Hour');

  // Load settings from localStorage on initial render
  useEffect(() => {
    const savedSettings = localStorage.getItem(SETTINGS_KEY);
    if (savedSettings) {
      try {
        const parsedSettings = JSON.parse(savedSettings);
        
        // Set map tile provider
        if (parsedSettings.mapTileProvider) {
          const provider = config.map_tile_providers.find(p => p.name === parsedSettings.mapTileProvider);
          if (provider) {
            setMapTileProvider(provider);
          }
        }
        
        // Set timezone
        if (parsedSettings.timezone) {
          setTimezone(parsedSettings.timezone);
        }
        
        // Set event time span
        if (parsedSettings.eventTimeSpan) {
          setEventTimeSpan(parsedSettings.eventTimeSpan);
        }
      } catch (error) {
        console.error('Error parsing saved settings:', error);
      }
    }
  }, []);

  // Save settings to localStorage whenever they change
  useEffect(() => {
    const settings = {
      mapTileProvider: mapTileProvider.name,
      timezone,
      eventTimeSpan
    };
    
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  }, [mapTileProvider, timezone, eventTimeSpan]);

  // Get a list of all available timezones
  const getAvailableTimezones = () => {
    return [
      'UTC',
      'America/New_York',
      'America/Chicago',
      'America/Denver',
      'America/Los_Angeles',
      'Europe/London',
      'Europe/Paris',
      'Europe/Berlin',
      'Asia/Tokyo',
      'Asia/Shanghai',
      'Australia/Sydney',
      'Pacific/Auckland'
    ];
  };

  // Get a list of all available time spans
  const getAvailableTimeSpans = () => {
    return [
      'Last Hour',
      'Last 4 Hours',
      'Last 24 Hours',
      'Last 2 Days',
      'Last 7 Days'
    ];
  };

  return (
    <SettingsContext.Provider
      value={{
        mapTileProvider,
        setMapTileProvider,
        timezone,
        setTimezone,
        eventTimeSpan,
        setEventTimeSpan,
        mapTileProviders: config.map_tile_providers,
        availableTimezones: getAvailableTimezones(),
        availableTimeSpans: getAvailableTimeSpans()
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);